import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16v5","key":"svg-0"}],["path",{"d":"M14 16v5","key":"svg-1"}],["path",{"d":"M9 9h6l-1 7h-4z","key":"svg-2"}],["path",{"d":"M5 11c1.333 -1.333 2.667 -2 4 -2","key":"svg-3"}],["path",{"d":"M19 11c-1.333 -1.333 -2.667 -2 -4 -2","key":"svg-4"}],["path",{"d":"M12 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-5"}]]

const IconMan = createReactComponent('outline', 'man', 'Man', __iconNode);

export default IconMan;